import React, { useEffect, useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { styled, Button } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import PersonDetail from '../../../components/PersonDetail';
import { api } from '../../../api';
import { Person } from '../../../schema/person';
import StaffDetail from '../../../components/StaffDetail';

const EditPerson: React.FC = () => {
  const { person_id } = useParams();
  const [isStaff, setIsStaff] = useState<boolean>(false);
  useEffect(() => {
    if (person_id) {
      api
        .get<Person>(`/person/${person_id}`)
        .then((res) => {
          const { data } = res;
          // setIsStaff(data.person_type.is_staff);
          if (data.person_type.is_staff && (data.company.company_type_id == 2 || data.company.company_type_id == 1)) {
            setIsStaff(true)
          }
        })
        .catch((res) => res.json());
    }
  }, [person_id]);
  return (
    <RootContainer>
      <PageHeader text={isStaff ? 'แก้ไขข้อมูลบุคลากร' : 'แก้ไขข้อมูลบุคคล'} />
      <Button component={Link} to="/person" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        บุคคลในระบบ
      </Button>
      {isStaff ? (
        <StaffDetail person_id={person_id} editable />
      ) : (
        <PersonDetail person_id={person_id} editable />
      )}
    </RootContainer>
  );
};

export default EditPerson;

const RootContainer = styled('div')`
  padding: 24px;
`;
